import {createAction} from '@packages/utilities/create-action';
import {GlobalComponentSettingsPayload} from './types';

/**
 * Action type constants for global component settings.
 */
export const GLOBAL_COMPONENTS_SETTINGS_SAVE_REQUESTED =
  'GLOBAL_COMPONENTS_SETTINGS_SAVE_REQUESTED' as const;
export const GLOBAL_COMPONENTS_SETTINGS_SAVE_SUCCEEDED =
  'GLOBAL_COMPONENTS_SETTINGS_SAVE_SUCCEEDED' as const;
export const GLOBAL_COMPONENTS_SETTINGS_SAVE_FAILED =
  'GLOBAL_COMPONENTS_SETTINGS_SAVE_FAILED' as const;

/**
 * Action to request saving global component settings to site meta.
 */
export const globalComponentsSettingsSaveRequested = createAction<
  typeof GLOBAL_COMPONENTS_SETTINGS_SAVE_REQUESTED,
  GlobalComponentSettingsPayload
>(GLOBAL_COMPONENTS_SETTINGS_SAVE_REQUESTED);

/**
 * Multiplayer action type for remote global component settings updates.
 * Dispatched to connected clients when another client saves global component settings.
 */
export const MULTIPLAYER_GLOBAL_COMPONENT_SETTINGS_UPDATED_REMOTELY =
  'MULTIPLAYER_GLOBAL_COMPONENT_SETTINGS_UPDATED_REMOTELY' as const;

/**
 * Multiplayer action creator for remote global component settings updates.
 * Used by the backend to notify connected clients of settings changes.
 */
export const multiplayerGlobalComponentSettingsUpdatedRemotely = createAction<
  typeof MULTIPLAYER_GLOBAL_COMPONENT_SETTINGS_UPDATED_REMOTELY,
  GlobalComponentSettingsPayload
>(MULTIPLAYER_GLOBAL_COMPONENT_SETTINGS_UPDATED_REMOTELY);
